module.exports = __webpack_public_path__ + "img/sem-imagem.3cdd0e9d.png";